<template>

    <div class="search-autocomplete-container">

      <ais-instant-search :search-client="searchClient" index-name="articles">

        <ais-autocomplete>

          <div slot-scope="{ currentRefinement, indices, refine }">

            <div class="rounded shadow-light mb-4">

              <div class="input-group input-group-lg">

                <div class="input-group-prepend">

                  <span class="input-group-text border-0 pr-1">
                    <i class="far fa-search"></i>
                  </span>

                </div>

                <input
                  class="form-control border-0 px-1"
                  name="query"
                  type="search"
                  aria-label="Search our Articles"
                  aria-describedby="header-autocomplete-magnify"
                  :value="currentSearchQuery"
                  placeholder="Search our Articles"
                  @input="currentSearchQuery = $event.currentTarget.value; refine($event.currentTarget.value);"
                  @focus="searchActive = true"
                  @blur="searchActive = false"
                >

                <div class="input-group-append">

                  <div class="input-group-text border-0 py-0 pl-1 pr-3">

                    <button :disabled="!currentSearchQuery" class="btn btn-sm btn-primary text-white">
                      Search
                    </button>

                  </div>

                </div>

              </div>

            </div>

            <ul v-if="currentSearchQuery && searchActive" v-for="index in indices" :key="index.label" class="list search-autocomplete-results-container shadow-dark-lg">

              <li>

                <div class="search-autocomplete-results--stats">
                  <ais-stats/>
                </div>

                <ul>

                  <li v-for="hit in index.hits" :key="hit.objectID" class="search-autocomplete-results--hit">

                    <a :href="'/blog/' + hit.slug" class="text-dark d-block">

                      <span>
                        <i class="fas fa-file-alt hit-icon"></i>
                        <ais-highlight attribute="title" :hit="hit"/>
                      </span>

                    </a>

                  </li>

                </ul>

              </li>

            </ul>

          </div>

        </ais-autocomplete>

      </ais-instant-search>

    </div>

</template>

<script>

  import {
    AisInstantSearch,
    AisHighlight,
    AisSearchBox,
    AisStats,
    AisAutocomplete,
  } from 'vue-instantsearch';
  import algoliasearch from 'algoliasearch/lite';

  const searchClient = algoliasearch(
    'LR0S9K5SS3',
    '713ccedc9d4729c5c902d72bf0d3c969',
  );

  export default {

    data() {
      return {
        searchClient,
        currentSearchQuery: this.query,
        searchActive: false,
      };
    },

    props: ['query'],

    components: {
      AisInstantSearch,
      AisHighlight,
      AisSearchBox,
      AisStats,
      AisAutocomplete,
    },

  };

</script>

<style lang="scss">

  .search-autocomplete-container {

    position: relative;
    z-index: 10;

  }

  .search-autocomplete-results-container {

    position: absolute;
    top: 58px;
    right: 0;
    background: #fff;
    border-radius: 0;
    padding: 0;
    max-height: 400px;
    overflow-y: auto;
    left: 0;
    width: auto;
    margin: 0;
    border: 1px #e9ecef solid;
    z-index: 10;

    ul {

      list-style: none;
      padding: 0;

      li {
        padding: 12px 25px;
      }

    }

    .index-label {

      text-transform: uppercase;
      font-weight: 700;
      font-size: 12px;
      color: #4d5c6b;
      letter-spacing: 0.85px;
      display: block;
      padding: 15px 25px 0px;
      background: #e9ecef;

    }

    .search-autocomplete-results--stats {

      font-size: 10px;
      color: #838ca0;
      padding: 8px 25px;
      background: #e9ecef;

    }

    .search-autocomplete-results--hit {

      color: #000;
      border-bottom: 1px #dbdfe3 solid;
      transition: all 0.35s;
      position: relative;
      background: white;

      .hit-icon {

        margin-right: 13px;
        color: #18324c54;
        font-size: 17px;

      }

      &:hover {
        background: #e9ecef;
      }

      &:last-child {
        border-bottom: 0;
      }

    }

    .search-autocomplete-results--hit-post-date {

      display: inline-block;
      color: #99a6b1;
      font-size: 13px;
      float: right;
      margin: -5px 0 0 0;
      line-height: 1.5;

    }

    .ais-Highlight-highlighted {

      padding: 0;
      background: #e9ecef;
      color: #0080ff;
      font-weight: 700;

    }

  }


</style>
